import { createRouter, createWebHistory } from 'vue-router'
import { getToken, getTokenFromStorage } from '../utils/tool'
import Layout from '@/layout/index.vue';
import AppLayout from '../src/layout/home.vue'
// import LayoutEmpyt from '../src/layout/empyt.vue'
import Index from '../src/pages/index.vue'
// import Order from '../src/pages/order/index.vue'
import Personal from '../src/pages/personal/index.vue'
import Login from '../src/pages/login.vue'
import Product from '../src/pages/product/index.vue'

import ProductDetail from '../src/pages/product/detail.vue'
import ProductDeny from '../src/pages/product/deny.vue'

// import Schedule from '../src/pages/scheduled/index.vue'

import Orders from '../src/pages/orders/index.vue'
import orderDetail from '../src/pages/orders/detail.vue'
import tryExtension from '../src/pages/orders/extension.vue'

import orderAudit from '../src/pages/orders/audit.vue'
import orderAudit2 from '../src/pages/orders/audit2.vue'
import orderConfirm from '../src/pages/orders/confirm.vue'
import Aboutus from '../src/pages/personal/about.vue'
import Help from '../src/pages/personal/help.vue'
import FeedbackIndex from '../src/pages/feedback/index.vue'
import Privacy from '../src/pages/protocol/privacy.vue'
import Terms from '../src/pages/protocol/term.vue'

import Download from '../src/pages/promotion/download.vue'
import Before from '../src/pages/promotion/before.vue'

import Repayment from '../src/pages/promotion/repayment.vue'
// import Empyt from '../src/layout/empyt.vue';
import Empyt3 from '../src/layout/empyt3.vue';
import Empyt2 from '../src/layout/empty2.vue';

const routes = [
    {
        path:'/',
        name: 'Index',
        component: AppLayout,
        children:[
            {
                path:'',
                name: 'Home',
                component: Index,
                meta:{ title:'Index', bgcolor:'#F7F7F7' }
            },            
            {
                path:'personal',
                name: 'Personal',
                component: Personal,
                meta:{ title:'Personal', bgcolor:'#fff' }
            },
            {
              path:'order',
              name: 'order',
              component: Orders,
              meta:{ title:'Orders', bgcolor:'#fff' }
            }
        ]        
    },
    {
      path:'/protocol/term',
      name: 'term',
      component: Terms,
      meta:{ title:'Terms', bgcolor:'#fff' }
    },
    {
      path:'/protocol/privacy',
      name: 'privacy',
      component: Privacy,
      meta:{ title:'Privacy', bgcolor:'#fff' }
    },
    {
      path:'/feedback',
      name: 'Feedback',
      component: Layout,
      meta:{ title:'FeedBack', bgcolor:'#fff' },
      children:[
          {
              path:'',
              name: 'feedback',
              component: FeedbackIndex,
              meta:{ title:'FeedBack', bgcolor:'#fff' }
          }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta:{ title:'Login', bgcolor:'#fff' }
    },
    {
      path:"/product",
      component:Layout,
      children:[
        {
          path: ':pid',
          name: 'Product',
          component: Product,
          meta:{ title:'Product', bgcolor:'#fff' }
        },    
        {
          path: ':pid/detail',
          name: 'Product-Detail',
          component: ProductDetail,
          meta:{ title:'Detail', bgcolor:'#fff' }
        }, 
        {
          path: ':pid/denied',
          name: 'Product-Denied',
          component: ProductDeny,
          meta:{ title:'Denied', bgcolor:'#fff' }
        },  
      ]
    },     
    {
      path:"/orders/",
      name:'orders',
      component: Layout,
      meta:{ title:'Orders', bgcolor:'#F6F6F6'},
      children:[
        {
          path:"/orders/:id/extension",
          name:'Order_Extension',
          component: tryExtension,
          meta:{ title:'Extension', bgcolor:'#F6F6F6'}
        },
        {
          path:"/orders/:id/detail",
          name:'Order_Detail',
          component: orderDetail,
          meta:{ title:'Detail', bgcolor:'#fff'}
        },{
          path:"/orders/:id/audit",
          name:'Order_audit',
          component: orderAudit,
          meta:{ title:'Auditing', bgcolor:'#fff'}
        },{
          path:"/orders/audit",
          name:'Order_auditt',
          component: orderAudit2,
          meta:{ title:'Auditing', bgcolor:'#fff'}
        },{
          path:"/orders/:id/confirm",
          name:'Order_confirm',
          component: orderConfirm,
          meta:{ title:'Confirm', bgcolor:'#fff'}
        },
      ]
    },  
    {
      path: '/promotion',
      name: 'Promotion',
      component:Empyt3,
      children:[
        {
          path:"download",
          name:'download',
          component: Download,
          meta:{ title:'Installation Guide', bgcolor:'#fff'}
        },
        {
          path:"before",
          name:'before',
          component: Before,
          meta:{ title:'Apply Now', bgcolor:'#fff'}
        },        
      ]
    },
    {
      path: '/activity',
      name: 'Activity',
      component:Empyt2,
      children:[
        {
          path:"repayment",
          name:'repayment',
          component: Repayment,
          meta:{ title:'', bgcolor:'#fff'}
        },        
      ]
    },
    {
      path: '/personal',
      name: 'personal',
      component:Layout,
      children:[
        {
          path:"aboutus",
          name:'aboutus',
          component: Aboutus,
          meta:{ title:'About Us', bgcolor:'#fff'}
        },{
          path:"help",
          name:'help',
          component: Help,
          meta:{ title:'Help', bgcolor:'#fff'}
        }
      ]
    }
]
const router  = createRouter({
    history: createWebHistory('/'),
    routes
})
const whiteList = [
  '/promotion/download',
  '/activity/repayment',
  '/login',
   '/verify/contact2',
   '/orders/audit',
   '/joint',
   "/distribution",
   '/protocol/term',
  '/protocol/privacy'
]
router.beforeEach((to, from, next) => {
    document.title = to.meta.title ? to.meta.title : 'Index'    
    document.body.style.background = to.meta.bgcolor ? to.meta.bgcolor : '#fff'  
    document.body.parentElement.scrollTop = 0
    const hasToken = getToken() || getTokenFromStorage()   
    // alert(hasToken)   
    if (hasToken) {
      if (to.path === '/login') {        
        // next({ path: '/' })        
        next()
      } else {
        next()
      }
        
    } else {
      console.log(whiteList.indexOf(to.path));
      if (whiteList.indexOf(to.path) !== -1) {     
        next()        
      } else {
        let queryString = ""
        for(let x in to.query) {
          let content = to.query[x]
          if(x == 'adjust_referrer') {
            queryString += `&adjust_reftag=${content.replace("adjust_reftag=","")}`                
          } else {
            queryString += `&${x}=${content}`
          }              
        }       
        next(`/login?redirect=${to.path}${queryString}`)
        // NProgress.done()
      }
    }
  })
export default router